import { render, staticRenderFns } from "./myorders.vue?vue&type=template&id=8cdb3f0a&"
import script from "./myorders.vue?vue&type=script&lang=js&"
export * from "./myorders.vue?vue&type=script&lang=js&"
import style0 from "./myorders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports